// extracted by mini-css-extract-plugin
module.exports = {"left_list":"index_left_list__2zXyF","common":"index_common__2o7bY","header":"index_header__2su-3","body":"index_body__21hlp","body_one":"index_body_one__15FQI"};